import { reactive, computed } from 'vue';
import EventSessionsItemComponent
  from '@/components/events/blocks/event-sessions-item/event-sessions-item.vue';

export default {
  name: 'EventSessionsColumnComponent',
  props: {
    sessions: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    bgColor: {
      type: String,
      required: false,
      default: '#FFA400',
    },
    openDescriptions: {
      type: Boolean,
      required: false,
      default: false,
    },
    columns: {
      type: Number,
      required: false,
      default: 1,
    },
    showButtons: {
      type: Boolean,
      required: false,
      default: true,
    },
    showDate: {
      type: Boolean,
      required: false,
      default: true,
    },
    dayColumns: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  components: { EventSessionsItemComponent },
  setup(props) {

    const state = reactive({
      sessions: props.sessions,
      bgColorStyleObject: computed(() => {
        if(props.dayColumns) {
          return {'background': 'inherit'};
        }
        return {'background': props.bgColor};
      }),
    });

    return { state };
  },
};
